<script>
    import { slide } from 'svelte/transition';
    import { createEventDispatcher } from 'svelte';

    export let tags = [];
    const dispatch = createEventDispatcher();
</script>

<div transition:slide class="c-search-terms">
    {#each tags as tag (tag.id)}
        <div class="c-search-terms__item">
            <span class="c-search-terms__label">{tag.label}</span>
            <button class="c-search-terms__remove" on:click|preventDefault={e => dispatch('removeTag', tag.id)}>
                <span class="u-screen-reader-only">Rimuovi {tag.label} dai filtri di ricerca</span>
                <i class="fas fa-times"></i>
            </button>
        </div>
    {/each}
</div>
